<div class="header {{ pageName }}">
  <div *ngIf="!is_superUser">
    <app-alert
      *ngIf="accessDenied"
      text="Ваш доступ к CRM ограничен"
      tooltip="Обратитесь к администрации"></app-alert>
  </div>
  <div class="header_inner d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <h2
        (click)="getLocation()"
        class="m-0 title"
        [class.cursor_pointer]="!!titleLink"
        *ngIf="title">
        {{ title }}
      </h2>
      <input
        [(ngModel)]="editTitle"
        (keyup)="change()"
        [class.is-invalid]="editTitle.length < 1"
        minlength="1"
        class="m-0 form-control header_edit_title"
        *ngIf="editTitle !== null && !notEditable" />
      <div class="ml-3 d-flex">
        <span
          *ngIf="loading"
          matTooltip="Изменения сохраняются"
          class="spinner"></span>
        <fa-icon
          class="check_icon"
          *ngIf="!loading && loading !== null && !notEditable"
          matTooltip="Все изменения сохранены"
          [icon]="faCheck"></fa-icon>
      </div>
      <h2 *ngIf="notEditable">{{ editTitle }}</h2>
    </div>

    <div class="d-flex align-items-center mainPage">
      <div class="header_content">
        <ng-content></ng-content>
      </div>
      <div
        *ngIf="showLogoutBtn"
        (click)="logout()"
        matTooltip="Выйти"
        class="icon header_logout_icon">
        <fa-icon [icon]="faLogout"></fa-icon>
      </div>
    </div>
  </div>
</div>
